import { ethers, Contract } from 'ethers'
import { Web3Provider } from '@ethersproject/providers'

import { OMNIPOOL_CONFIG } from '~/lib/config'

import MerkleDistributor from './abi/MerkleDistributor.json'

const CLAIM_ALL_ADDRESS = OMNIPOOL_CONFIG.claimAll.address

export function getClaimAllContractV2(provider: Web3Provider): Contract {
	return new ethers.Contract(CLAIM_ALL_ADDRESS, MerkleDistributor, provider)
}
